<script>
    import {
        useForm,
        validators,
        HintGroup,
        Hint,
        email,
        required,
        minLength,
    } from "svelte-use-form";
    import { passwordMatch } from "./customValidators";
    import { emailAlreadyInUse } from "./errorCodes";
    import {
        createUserWithEmailAndPassword,
        sendEmailVerification,
    } from "firebase/auth";

    export let auth;

    const form = useForm();

    let serverError;

    async function handleSubmit(event) {
        event.preventDefault();
        try {
            serverError = undefined;
            await createUserWithEmailAndPassword(
                auth,
                $form.email._value,
                $form.password._value
            );
            await sendEmailVerification(auth.currentUser);
            alert(
                "Email de verificação enviado.\nPor favor verifica o teu email para poderes usar a aplicação!"
            );
            window.location.href = "/login";
        } catch (error) {
            serverError = error;
            return false;
        }
    }
</script>

<div id="login-div">
    <div id="login-frame">
        <h1>Registar</h1>
        <form use:form>
            <label for="email">Email</label>
            <input
                type="email"
                name="email"
                cy_data="email-register"
                use:validators={[required, email]}
            />
            <HintGroup for="email">
                <Hint on="required">
                    <p class="hint">Campo obrigatório</p>
                </Hint>
                <Hint on="email" hideWhenRequired
                    ><p class="hint">Email inválido</p>
                </Hint>
            </HintGroup>

            <label for="password">Palavra passe</label>
            <input
                type="password"
                name="password"
                cy_data="password-register"
                use:validators={[required, minLength(8)]}
            />
            <Hint for="password" on="required"
                ><p class="hint">Campo obrigatório</p></Hint
            >
            <Hint for="password" on="minLength">
                <p class="hint">
                    A palavra passe tem de ter, pelo menos, oito caracteres
                </p>
            </Hint>

            <label for="password">Repetir palavra passe</label>
            <input
                type="password"
                name="password-repeat"
                cy_data="password-repeat-register"
                use:validators={[passwordMatch]}
            />
            <Hint for="password-repeat" on="passwordMatch">
                <p class="hint">As duas palavras passe não correspondem</p>
            </Hint>

            <div id="button-div">
                <button
                    disabled={!$form.valid}
                    on:click={handleSubmit}
                    cy_data="register-button"
                >
                    Registar
                </button>
            </div>
        </form>

        <div id="error">
            {#if typeof serverError !== "undefined"}
                {#if serverError.code === emailAlreadyInUse}
                    <p cy_data="user-already-exists">
                        Já existe uma conta com este email 🙅‍♂️
                    </p>
                {:else}
                    <p>
                        Ocorreu um erro desconhecido! Volta a tentar mais tarde
                        🙏
                    </p>
                {/if}
            {/if}
        </div>
    </div>
</div>

<!-- <pre>
{JSON.stringify($form, null, " ")}
</pre> -->

<style>
    #login-div {
        display: flex;
        flex-direction: column;
        place-items: center;
        text-align: center;
    }

    #login-frame {
        width: fit-content;
        max-width: min-content;

        margin-top: 2rem;
        margin-bottom: 2rem;

        padding: 2rem;
        padding-left: 3rem;
        padding-right: 3rem;

        border-style: solid;
        border-width: 3px;
        border-color: #164e63;
        border-radius: 0.375rem;
    }

    h1 {
        margin-bottom: 1rem;
        font-size: large;
        font-weight: 600;
    }

    form {
        display: flex;
        flex-direction: column;
        place-items: start;
        text-align: start;
    }

    #button-div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    button {
        display: flex;
        color: #f1f5f9;
        background-color: #164e63;

        width: fit-content;

        border-radius: 0.375rem;

        margin-top: 1rem;
        margin-bottom: 1rem;

        padding-left: 0.5rem;
        padding-right: 0.5rem;
        padding-top: 0.25rem;
        padding-bottom: 0.4rem;
    }

    button:disabled {
        background-color: #445e77;
        cursor: not-allowed;
    }

    button:hover {
        color: #d4d4d4;
    }

    button:active {
        background-color: #155e75;
    }

    .hint {
        font-size: small;
    }

    input {
        border-color: transparent;
        border-width: 2px;
        border-radius: 0.375rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    :global(.touched:invalid) {
        border-color: red;
        outline-color: red;
    }

    #error {
        color: red;
        margin-bottom: 0.75rem;
    }
</style>
